import { Outlet } from 'react-router-dom'

import { ThemeToggle } from '@/shared/components/common'
import { useT } from '@/shared/i18n'

export function AuthLayout() {
  const t = useT()

  return (
    <div className="flex min-h-dvh flex-col bg-bg text-text-1">
      <div className="flex justify-end p-3">
        <ThemeToggle />
      </div>

      <div className="flex flex-1 items-center justify-center px-4 pb-16">
        <div className="w-full max-w-[340px]">
          <div className="mb-6 flex items-center gap-2">
            <span aria-hidden="true" className="h-5 w-[var(--spine-w)] rounded-full bg-signal" />
            <span className="font-display text-lg">{t('nav.appName')}</span>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
